<template><App :keepAliveInclude="keepAliveInclude"/></template><script>
	import {onLang} from "@/utils/toLang.js"
  export default {
    onLaunch: function() {
    },
    onLoad() {
    },
    onShow: function() {
		onLang()
      // console.log('App Show')
    },
    onHide: function() {
      // console.log('App Hide')
    }
  }
</script>

<style lang="scss">
  /* 注意要写在第一行，同时给style标签加入lang="scss"属性 */
  @import "@/uni_modules/uview-ui/index.scss";
  @import '@/static/css/comm.scss';
</style>